import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../../components/Loader/loader";
import NotFound from "../../../../components/NotFound/not-found";
import ProductDetailsComponent from "../../../../components/ProductSection/product-section";
import ProductDetailsData from "./data.json";
import { Box, Grid2 as Grid, Typography } from "@mui/material";
import ProductCarousel from "../../../../components/Carousel/product-carousel";
//import IconTablaNutrimental from '../../../../assets/images/icon-tabla_nutrimental-2.png';
import IconIngredientes from '../../../../assets/images/icon-ingredientes-2.png';
import ProductModal from '../../../../components/ProductModal/product-modal';
import './product-details.css';


function ProductDetails() {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({ type: '', content: '' });
    const { product } = useParams();

    const icons = [
        //{ src: IconTablaNutrimental, text: "Tabla nutrimental", type: "nutritional" },
        { src: IconIngredientes, text: "Ingredientes", type: "ingredients" }
    ];

    useEffect(() => {
        const getDetails = async () => {
            const productData = ProductDetailsData.find(item => item.product === product);
            if (productData) {
                setData(productData);
            } else {
                setData(null);
            }
            setIsLoading(false);
        }
        getDetails();
    }, [product]);

    if (isLoading) {
        return <Loader />
    }
    if (!data) {
        return <NotFound />;
    }

    const openModal = (type, content) => {
        const contentData = type === 'nutritional' ? content.nutritionalTable : content.ingredients;
        setModalContent({ type, content: contentData });
        setModalOpen(true);
    };

    const closeModal = () => setModalOpen(false);

    return (
        <Box className="product-details">
            <Grid container spacing={5} className="product-details__grid">
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }} className="product-details__images">
                    <ProductCarousel images={data.productImages} customClass="product-details__carousel" />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }} className="product-details__description">
                    <Box className="product-details__description-title">
                        <Typography variant="h4" className="product-details__description-text--title">
                            {data.family}
                        </Typography>
                    </Box>
                    <Box className="product-details__description-text">
                        <Typography variant="body1" className="product-details__description-text--title-product">
                            {data.title}
                        </Typography>
                        <Typography variant="body1" className="product-details__description-text--description" dangerouslySetInnerHTML={{ __html: data.description }} />
                    </Box>
                    <Box className="product-details__description-icons">
                        {icons.map((icon, idx) => (
                            <Box key={idx} className="product-details__image-icon-container" onClick={() => openModal(icon.type, data)}>
                                <Box
                                    component="img"
                                    src={icon.src}
                                    className="product-details__image-icon"
                                    alt={icon.text}
                                />
                                <Typography variant="caption" className="product-details__image-icon-text">
                                    {icon.text}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Grid>
            </Grid>
            <ProductDetailsComponent data={data} elementsByRow={4} title={data.family} />
            <ProductModal
                open={isModalOpen}
                handleClose={closeModal}
                type={modalContent.type}
                content={modalContent.content}
            />
        </Box>
    )
}

export default ProductDetails;